import PropTypes from 'prop-types';

const SIZES = {
	md: { track: 'h-6 w-11', knob: 'h-5 w-5', on: 'translate-x-5', off: 'translate-x-0' },
	sm: { track: 'h-5 w-9', knob: 'h-4 w-4', on: 'translate-x-4', off: 'translate-x-0' },
};

export default function Switch({
	checked,
	onChange,
	disabled = false,
	size = 'md',
	label,
	id,
	className = '',
	...props
}) {
	const sizes = SIZES[size];

	const control = (
		<button
			type="button"
			role="switch"
			id={id}
			aria-checked={checked}
			onClick={() => onChange?.(!checked)}
			disabled={disabled}
			className={`relative inline-flex ${sizes.track} shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${
				checked ? 'bg-primary-500' : 'bg-bgBase-500'
			} ${label ? '' : className}`}
			{...props}
		>
			<span
				aria-hidden="true"
				className={`pointer-events-none inline-block ${sizes.knob} transform rounded-full bg-white shadow ring-0 transition-transform duration-200 ease-in-out ${
					checked ? sizes.on : sizes.off
				}`}
			/>
		</button>
	);

	if (!label) return control;

	return (
		<label className={`flex items-center gap-3 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}>
			{control}
			<span className="text-sm text-text select-none">{label}</span>
		</label>
	);
}

Switch.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	size: PropTypes.oneOf(['md', 'sm']),
	label: PropTypes.node,
	id: PropTypes.string,
	className: PropTypes.string,
};
